module.exports = __webpack_public_path__ + "static/media/cover-website-csep.9ae5911e.jpg";